module.exports = __webpack_public_path__ + "img/area-limit-bg.220fc17f.png";